import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DeclineCategoryRow } from '../interfaces/decline-reason-mapping.interface';
import { DeclineMappingGridContext, DeclineMappingGridHostApi } from '../interfaces/decline-mapping-grid-host.interface';

@Component({
  selector: 'decline-mapping-delete-cell',
  templateUrl: './decline-mapping-delete-cell.component.html',
  styleUrls: ['./decline-mapping-cell-renderers.styles.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeclineMappingDeleteCellComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>;

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>): boolean {
    this.params = params;
    this.cdr.markForCheck();
    return true;
  }

  get host(): DeclineMappingGridHostApi | undefined {
    return this.params?.context?.host;
  }

  get row(): DeclineCategoryRow | undefined {
    return this.params?.data;
  }

  onDelete(ev: MouseEvent): void {
    ev.stopPropagation();
    if (!this.row?.id || !this.host) {
      return;
    }
    this.host.requestDeleteConfirm(this.row.id);
  }
}
